// @flow
import * as React from 'react';
import { detectExperiment, setExperiment } from '../../redux/modules/googleOptimize';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getUserExperimentVariant } from '../../redux/modules/userVariantTest';
import { setUseGeoLocation } from '../../redux/modules/search';

type OwnProps = {||};

const mapStateToProps = state => {
    const userExperiment = getUserExperimentVariant(state, 'LOG0fFiUTUyn3DH5w_OFLw');
    const useGeo = Boolean(userExperiment.variantId);
    return {
        useGeo,
        userExperiment,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            detectExperiment,
            setExperiment,
            setUseGeoLocation,
        },
        dispatch
    );

type ReduxProps = {|
    useGeo: boolean,
    userExperiment: any,
|};

type ReduxActions = {|
    detectExperiment: Function,
    setExperiment: Function,
    setUseGeoLocation: Function,
|};

type Props = {|
    ...OwnProps,
    ...ReduxProps,
    ...ReduxActions,
|};

class GeoLocationSearchExperimentContainer extends React.Component<Props> {
    componentDidMount() {
        this.setupGeoLocationSearchExperiment();
    }

    setupGeoLocationSearchExperiment = () => {
        const { useGeo, userExperiment } = this.props;
        const { experimentId, variantId } = userExperiment;
        this.props.setUseGeoLocation(useGeo);
        this.props.setExperiment(`${experimentId}.${variantId}`);
        this.props.detectExperiment();
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoLocationSearchExperimentContainer);
